import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

const STORAGE_KEY = 'thriftlo_lang';

function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'sv') return stored;
  } catch (_) {}
  return 'en';
}

const lng = getStoredLanguage();

// Always bundle English (default/fallback). Swedish is loaded on demand.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// If the user's stored language is Swedish, load it now and switch
if (lng === 'sv') {
  import('./locales/sv.json').then((module) => {
    i18n.addResourceBundle('sv', 'translation', module.default, true, true);
    i18n.changeLanguage('sv');
  });
}

i18n.on('languageChanged', (newLng) => {
  try {
    localStorage.setItem(STORAGE_KEY, newLng);
  } catch (_) {}
});

export default i18n;
